import 'vite/modulepreload-polyfill';
import '@oddbird/popover-polyfill';
import { revive, islands } from '@/js/revive.js';
import { addJudgeMeOffset } from '@/js/add-judgme-offset.js';

revive(islands);
addJudgeMeOffset();
